import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { SNETDialog, SNETButton } from "shared/dist/components";

const UserConfirmationModal = ({
    isModalOpen,
    handleModalClose,
    title,
    hadleDecline,
    handleConfirm,
    dialogSlotProps,
}) => {
    return (
        <SNETDialog
            isDialogOpen={isModalOpen}
            onDialogClose={handleModalClose}
            title={title}
            slotProps={dialogSlotProps}
        >
            <Box sx={{ display: "flex", gap: 3, justifyContent: "center" }}>
                <SNETButton
                    children="Cancel"
                    color="red"
                    variant="outlined"
                    onClick={handleModalClose}
                />
                <SNETButton
                    children="No"
                    color="primary"
                    variant="outlined"
                    onClick={hadleDecline}
                />
                <SNETButton
                    children="Yes"
                    color="primary"
                    variant="contained"
                    onClick={handleConfirm}
                />
            </Box>
        </SNETDialog>
    );
};

UserConfirmationModal.propTypes = {
    isModalOpen: PropTypes.bool,
    title: PropTypes.string,
    handleModalClose: PropTypes.func,
    hadleDecline: PropTypes.func,
    handleConfirm: PropTypes.func,
    dialogSlotProps: PropTypes.object,
};

export default UserConfirmationModal;
